// Situação da transação na Phoebus/PayStore (campo `status` de /v3/payments).
const phoebusStatusLabels: Record<number, string> = {
  0: 'Pendente',
  1: 'Confirmada',
  2: 'Desfeita',
  3: 'Negada',
};

export const phoebusStatusLabel = (status?: number | null) => {
  if (status === undefined || status === null) {
    return '-';
  }

  return phoebusStatusLabels[status] ?? String(status);
};
